export default "__VITE_ASSET__15a4b91c__"